/**
 *
 * Asynchronously loads the component for ReportingDashboardPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
